<ng-container *ngIf="{
    row: columnData | async,
    aData: additionData | async
  } as $">
  <span *ngIf="$.row && $.aData && !isEmptyAndNull($.row[$.aData.fetch_key]);else empty"> {{ getServiceValidity($.row[$.aData.fetch_key]) | async}}</span>
  <ng-template #empty>-</ng-template>
</ng-container>

